export default {
    'name': 'warning',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<path d=\'M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z\' stroke=\'#026958\' stroke-width=\'2\' stroke-miterlimit=\'10\'/><path d=\'M16 10V17\' stroke=\'#026958\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M16 23C16.8284 23 17.5 22.3284 17.5 21.5C17.5 20.6716 16.8284 20 16 20C15.1716 20 14.5 20.6716 14.5 21.5C14.5 22.3284 15.1716 23 16 23Z\' fill=\'#026958\'/>'
}
